import { ComponentProps, useCallback, useMemo, useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { Content } from 'src/contexts/ContentContext';
import { useEventHubContext } from 'src/contexts/EventHubContext/EventHubContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Stack, Tooltip } from 'src/core/ui';
import { GroupListingsModal } from 'src/modals/GroupListings';
import { CompanionModeEnterIcon, CompanionModeExitIcon } from 'src/svgs';
import { ContentId } from 'src/utils/constants/contentId';
import { Event } from 'src/WebApiController';

import * as styles from './EventActions.css';

export const EnterCompanionMode = ({
  event,
}: ComponentProps<typeof GroupListingsModal> & {
  event?: Event;
}) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(elementRef);
  const { onStartSession, onCancelSession, sessionRole } = useEventHubContext();
  const { isDarkMode } = useSiteTheme();

  const onToggleComapnionMode = useCallback(() => {
    if (sessionRole) {
      onCancelSession();
    } else {
      onStartSession();
    }
  }, [onStartSession, onCancelSession, sessionRole]);

  const iconColor = useMemo(() => {
    if (isHovering) {
      return vars.color.iconHover;
    }
    return vars.color.textPrimary;
  }, [isHovering]);

  return (
    <Tooltip
      open={isHovering}
      delayDuration={100}
      contentVariant={isDarkMode ? 'light' : 'dark'}
      align="center"
      triggerContent={
        <Stack
          ref={elementRef}
          onClick={onToggleComapnionMode}
          className={styles.eventActionsGroupItem}
        >
          {sessionRole ? (
            <CompanionModeExitIcon
              withHoverEffect
              fill={iconColor}
              size={vars.iconSize.l}
            />
          ) : (
            <CompanionModeEnterIcon
              withHoverEffect
              fill={iconColor}
              size={vars.iconSize.l}
            />
          )}
        </Stack>
      }
    >
      <Content
        id={
          sessionRole
            ? ContentId.ExitCompanionMode
            : ContentId.EnterCompanionMode
        }
      />
    </Tooltip>
  );
};
